<template>
  <div class="text-center">
    <v-dialog v-model="show" width="1024" persistent>
      <v-form fast-fail @submit.prevent="submit">
      <v-card>
        <v-toolbar color="primary" :title="$t('target.title')">
          <v-chip prepend-icon="mdi-account">{{ user }}</v-chip>&nbsp;
          <v-btn
                type="submit"
                variant="tonal"
				prepend-icon="mdi-content-save"
            >
              {{ $t("shelter.save") }}
            </v-btn>&nbsp;
            <v-btn
				variant="tonal"
                prepend-icon="mdi-close-circle"
                @click="show = false"
            >{{ $t("shelter.cancel") }}
            </v-btn>
        </v-toolbar>
          <v-card-title v-if="false">
            <span class="text-h5" v-if="!target_id">{{ $t("target.addTarget") }}</span>
						<span class="text-h5" v-else>{{ $t("target.editTarget") }} {{target_id}}</span>
          </v-card-title>
          <v-card-text>
            <v-container>
              <v-row>
                <v-col cols="12">
                  <v-text-field :label="$t('target.targetName')" v-model="form.name"></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field :label="$t('target.targetAddress')" v-model="form.address"></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                    <v-text-field :label="$t('target.longitude')" suffix="°" v-model="form.x" readonly></v-text-field>
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field :label="$t('target.latitude')" suffix="°" v-model="form.y" readonly></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-textarea :label="$t('target.targetDescription')" v-model="form.description"></v-textarea>
                </v-col>
              </v-row>
            </v-container>
          </v-card-text>
        </v-card>
      </v-form>
    </v-dialog>
  </div>
</template>

<script>

import {useTargetStore} from "@/stores/targetStore";
import {useShelterStore} from "@/stores/shelterStore"

export default {
  name: "addTargetDialog",
  data () {
    return {
      show: false,
      target_id: null,
      user: null,
      form: {
        name: null,
        x: null,
        y: null,
        address: null,
        description: null
      },
      rules: [
        value => {
          if (value) return true
          return false
        }
      ]
    }
  },
  methods: {
    async showDialog(coords) {
			if(coords.id) {
				this.$data.target_id = coords.id
				let info = useTargetStore().$state.targets.find(t => t.id == coords.id)
				this.$data.user = info.user
				this.$data.form.address = info.address
				this.$data.form.x = info.x
				this.$data.form.y = info.y
        this.$data.form.name = info.name
        this.$data.form.description = info.description
			}
			else {
        this.$data.user = this.$keycloak.tokenParsed.preferred_username
				this.$data.target_id = null
				this.$data.form.name = null
				this.$data.form.y = coords.lng
				this.$data.form.x = coords.lat
        this.$data.form.address = null
        this.$data.form.description = null
			}
			if(coords.label) {
				this.$data.form.address = coords.label.toString()
			}
      this.$data.show = true
    },
    async submit() {
      //if(this.$data.form.name) {
				this.$data.show = false
				if(!this.$data.target_id) {
					await useTargetStore().createTarget(this.$data.form)
          await useShelterStore().getUserShelters()
				}
				else {
					await useTargetStore().updateTarget(this.$data.form, this.$data.target_id)
				}
      //}
      //this.$data.form.name = null
    }
  },
}
</script>
